import { FormattedMessage } from 'react-intl';

export const organisationSelectorMessages = {
  'organisationSelector.title': (
    <FormattedMessage
      id="organisationSelector.title"
      defaultMessage="Choose a society"
    />
  ),
  'organisationSelector.description': (
    <FormattedMessage
      id="organisationSelector.description"
      defaultMessage="You have multiple societies to administer, choose from the dropdown to proceed."
    />
  ),
  'organisationSelector.dropdown.label': (
    <FormattedMessage
      id="organisationSelector.dropdown.label"
      defaultMessage="Society"
    />
  ),
  'organisationSelector.button.confirm.label': (
    <FormattedMessage
      id="organisationSelector.button.confirm.label"
      defaultMessage="Proceed"
    />
  ),
  'organisationSelector.button.cancel.label': (
    <FormattedMessage
      id="organisationSelector.button.cancel.label"
      defaultMessage="Cancel"
    />
  ),
};
